const log = {
  logsBelong: 'Belong To',
  recorder: 'Recorder',
  logType: 'Log Type',
  loginType: 'Login Type',
  content: 'Content',
  export: 'Export',
  details: 'Details',
}
export default log